

// color-swatches.js

const COLOR_MAP = {
  'Amarillo': '#FFFF00',
  'Azul': '#0000FF',
    'Arena': '#e7ce8c',
      'Beige': '#F5F5DC',
        'Blanco': '#FFFFFF',
          'Burdeo': '#800020',
            'Calipso': '#00FFEF',
              'Camel': '#C19A6B',
                'Canela': '#D2691E',
                  'Celeste': '#87CEEB',
                    'Coral': '#FF7F50',
                      'Crema': '#FFFDD0',
                        'Frambuesa': '#E30B5D',
                          'Fucsia': '#FF00FF',
                            'Grafito': '#383838',
                              'Gris': '#808080',
                                'Gris Claro': '#D3D3D3',
                                  'Gris Piedra': '#828282',
                                    'Jade': '#00A86B',
                                      'Ladrillo': '#B22222',
                                        'Lavanda': '#E6E6FA',
                                            'Lila': '#C8A2C8',
                                              'Malva': '#E0B0FF',
                                                'Melange Beige': '#E8DCC4',
                                                  'Melange Grafito': '#464646',
                                                    'Melange Gris': '#919191',
                                                      'Melange Gris Claro': '#D6D6D6',
                                                        'Melange Verde': '#89AC76',
                                                          'Morado': '#800080',
                                                            'Morado Claro': '#9370DB',
                                                              'Morado Oscuro': '#4B0082',
                                                                'Mostaza': '#FFE4B5',
                                                                  'Mostaza Oscuro': '#CC9933',
                                                                    'Naranjo': '#FFA500',
                                                                      'Negro': '#000000',
                                                                        'Petroleo': '#005F69',
                                                                          'Petróleo': '#005F69',
                                                                            'Rojo': '#FF0000',
                                                                              'Rojo Oscuro': '#8B0000',
                                                                                'Rosa': '#FFC0CB',
                                                                                  'Rosado': '#FF69B4',
                                                                                    'Terracota': '#E2725B',
                                                                                      'Turquesa': '#40E0D0',
                                                                                        'Turquesa Oscuro': '#00868B',
                                                                                          'Verde': '#008000',
                                                                                            'Verde Oscuro': '#006400',
                                                                                              'Vino': '#722F37',
                                                                                                'Violeta': '#8F00FF',
                                                                                                  'Cafe': '#6F4E37',
                                                                                                    'Café': '#6F4E37'
                                                                                                    };

function normalizeText(text) {
  return text.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function isLightColor(hexColor) {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 155;
}

class SimpleColorCheckboxManager {
  constructor() {
    this.processedElements = new WeakSet();
    this.observer = null;
    this.normalizedColorMap = Object.entries(COLOR_MAP).reduce((acc, [key, value]) => {
      acc[normalizeText(key)] = value;
      return acc;
    }, {});
  }

  init() {
    this.observer = new MutationObserver(() => this.updateColorCheckboxes());
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    this.updateColorCheckboxes();
  }

  updateColorCheckboxes() {
    const filterLabels = document.querySelectorAll('.facets__label:not([data-color-filter]), .mobile-facets__label:not([data-color-filter])');
    
    filterLabels.forEach(label => {
      if (this.processedElements.has(label)) return;
      
      const textElement = label.querySelector('.facet-checkbox__text-label');
      if (!textElement) return;
      
      const colorName = textElement.textContent.trim();
      const normalizedColorName = normalizeText(colorName);
      const colorHex = this.normalizedColorMap[normalizedColorName];
      
      if (colorHex) {
        this.processedElements.add(label);
        label.setAttribute('data-color-filter', 'true');
        
        if (isLightColor(colorHex)) {
          label.classList.add('light-color');
        }
        
        const rect = label.querySelector('svg rect');
        if (rect) {
          rect.setAttribute('fill', colorHex);
          rect.setAttribute('stroke', isLightColor(colorHex) ? '#ddd' : colorHex);
        }
      }
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Inicializar
const checkboxManager = new SimpleColorCheckboxManager();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => checkboxManager.init());
} else {
  checkboxManager.init();
}
